import React from "react";
import { logo_white } from "../../Assets";
import AccountMenu from "../../Components/GeneralComponents/AccountMenu";
import { useContent } from "../../hooks/useContent";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "../../Components/GeneralComponents/Breadcrumbs";

export default function AppHeader() {
  const { pageHeading } = useContent();

  return (
    <header className="header shadow-sm">
      <div className="container py-3">
        <div className="d-flex justify-content-between align-items-center">
          <NavLink to="/">
            <img
              src={logo_white}
              alt="Logo"
              className="app-logo cursor-pointer"
            />
          </NavLink>
          <div className="text-center flex-fill">
            <h2 className="mb-0 fw-bold">{pageHeading}</h2>
            <Breadcrumbs />
          </div>
          <div className="text-secondary small" style={{ width: '200px', textAlign: 'right' }}>
            <AccountMenu />
          </div>
        </div>
      </div>
    </header>
  );
}
